const websiteRegex = /^(https?:\/\/)?([a-z0-9][a-z0-9\\-]*\.)+[a-z0-9][a-z0-9\\-]*([\/?#].*)?$/i;
const validateWebsite = (value) => {
    if (value === null || value === undefined || value === '')
        return true;
    return websiteRegex.test(value);
};
export default validateWebsite;
